class ImageGallery {
    constructor() {
        // Controlla se l'elemento con data-cover-image-gallery esiste
        this.coverImageGallery = document.querySelector('[data-cover-image-gallery]');

        if (this.coverImageGallery) {
            this.init();
        }
    }

    init() {
        // Seleziona tutti gli elementi con la classe 'image-item'
        const imageItems = document.querySelectorAll('.image-item img');

        // Aggiungi un evento di clic a ciascun elemento immagine
        imageItems.forEach((imageItem, index) => {
            imageItem.addEventListener('click', () => {
                this.changeCoverImage(imageItem.src);
            });
        });

        // Inizializza la lite gallery
        this.initLiteGallery();

        // Listener per l'aggiornamento del prodotto quando cambia la variante
        this.setupProductUpdateListener();
    }

    /**
     * Configura il listener per l'aggiornamento del prodotto
     * Quando cambia una variante, PrestaShop fa un refresh AJAX e aggiorna le immagini
     */
    setupProductUpdateListener() {
        // Verifica se PrestaShop è disponibile
        if (typeof prestashop !== 'undefined') {
            const self = this;

            // Listener per quando il prodotto viene aggiornato (dopo il refresh AJAX)
            prestashop.on('updatedProduct', function (event) {
                // Aspetta che il DOM sia aggiornato
                setTimeout(function () {
                    // Re-inizializza la gallery con le nuove immagini
                    self.reinitGallery();
                }, 100);
            });
        }
    }

    /**
     * Re-inizializza la gallery dopo l'aggiornamento del prodotto
     */
    reinitGallery() {
        // Rimuovi i listener esistenti dalle vecchie immagini
        const oldImageItems = document.querySelectorAll('.image-item img');
        oldImageItems.forEach((imageItem) => {
            // Clona l'elemento per rimuovere tutti i listener
            const newImageItem = imageItem.cloneNode(true);
            imageItem.parentNode.replaceChild(newImageItem, imageItem);
        });

        // Seleziona nuovamente tutti gli elementi con la classe 'image-item'
        const imageItems = document.querySelectorAll('.image-item img');

        // Aggiungi un evento di clic a ciascun elemento immagine
        imageItems.forEach((imageItem, index) => {
            imageItem.addEventListener('click', () => {
                this.changeCoverImage(imageItem.src);
            });
        });

        // Aggiorna l'immagine di copertura con la prima immagine disponibile
        if (imageItems.length > 0) {
            const firstImage = imageItems[0];
            const coverImage = document.querySelector('.image-container .cover-image img');
            if (coverImage) {
                if (firstImage.src !== coverImage.src) {
                    this.changeCoverImage(firstImage.src);
                }
            }
        }

        // Re-inizializza la lite gallery se necessario
        // Rimuovi l'overlay e il magnifier esistenti se ci sono
        const existingOverlay = document.querySelector('.image-overlay');
        const existingMagnifier = document.querySelector('.image-magnifier');
        if (existingOverlay) {
            existingOverlay.remove();
        }
        if (existingMagnifier) {
            existingMagnifier.remove();
        }

        // Re-inizializza la lite gallery
        this.initLiteGallery();
    }

    changeCoverImage(newImageUrl) {
        // Seleziona l'immagine di copertura
        const coverImage = document.querySelector('.image-container .cover-image img');

        // Sostituisci l'URL dell'immagine di copertura con quello dell'immagine cliccata
        if (coverImage) {
            coverImage.src = newImageUrl;
        }
    }

    initLiteGallery() {
        // Cerca l'elemento con data-cover-img
        let coverImageContainer = document.querySelector('[data-cover-img]');

        if (!coverImageContainer) {
            return;
        }

        // Crea l'overlay trasparente che copre tutta l'immagine
        const imageOverlay = document.createElement('div');
        imageOverlay.className = 'image-overlay';
        imageOverlay.style.cssText = `
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            height: 100% !important;
            background: transparent !important;
            cursor: pointer !important;
            z-index: 10 !important;
        `;

        // Aggiungi click all'overlay per aprire la gallery
        imageOverlay.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.openLiteGallery();
        });

        // Crea la lente di ingrandimento con l'icona SVG
        const magnifier = document.createElement('div');
        magnifier.className = 'image-magnifier';
        magnifier.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
            </svg>
        `;
        magnifier.style.cssText = `
            position: absolute !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%) !important;
            background: rgba(0, 0, 0, 0.7) !important;
            color: white !important;
            width: 60px !important;
            height: 60px !important;
            border-radius: 50% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            opacity: 0 !important;
            transition: opacity 0.3s ease !important;
            pointer-events: none !important;
            z-index: 15 !important;
            border: 2px solid white !important;
        `;

        coverImageContainer.style.position = 'relative';
        coverImageContainer.style.cursor = 'pointer';
        coverImageContainer.appendChild(imageOverlay);
        coverImageContainer.appendChild(magnifier);


        // Trova l'immagine dentro il container per applicare l'effetto hover
        const coverImg = coverImageContainer.querySelector('img');

        // Mostra la lente al hover e applica l'effetto all'overlay
        coverImageContainer.addEventListener('mouseenter', () => {
            magnifier.style.opacity = '1';
            imageOverlay.style.background = 'rgba(0, 0, 0, 0.2)';
            imageOverlay.style.transition = 'background 0.3s ease';
        });

        coverImageContainer.addEventListener('mouseleave', () => {
            magnifier.style.opacity = '0';
            imageOverlay.style.background = 'transparent';
        });


    }

    openLiteGallery() {
        // Blocca lo scroll del body
        document.body.style.overflow = 'hidden';

        // Crea il modal per la gallery
        const modal = document.createElement('div');
        modal.className = 'lite-gallery-modal';

        modal.innerHTML = `
            <div class="lite-gallery-overlay">
                <div class="lite-gallery-container">
                    <button class="lite-gallery-close">&times;</button>
                    <div class="lite-gallery-main">
                        <img class="lite-gallery-image" src="" alt="">
                    </div>
                    <div class="lite-gallery-thumbnails">
                        ${this.generateThumbnails()}
                    </div>
                    <div class="lite-gallery-nav">
                        <button class="lite-gallery-prev">&larr;</button>
                        <button class="lite-gallery-next">&rarr;</button>
                    </div>
                </div>
            </div>
        `;

        document.body.appendChild(modal);

        // Inizializza la gallery
        this.currentIndex = 0;
        this.images = this.getAllImages();
        this.showImage(0);

        // Event listeners
        modal.querySelector('.lite-gallery-close').addEventListener('click', () => {
            this.closeLiteGallery();
        });

        modal.querySelector('.lite-gallery-overlay').addEventListener('click', (e) => {
            if (e.target === modal.querySelector('.lite-gallery-overlay')) {
                this.closeLiteGallery();
            }
        });

        modal.querySelector('.lite-gallery-prev').addEventListener('click', () => {
            this.prevImage();
        });

        modal.querySelector('.lite-gallery-next').addEventListener('click', () => {
            this.nextImage();
        });

        // Thumbnail clicks
        modal.querySelectorAll('.lite-gallery-thumb').forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                this.showImage(index);
            });
        });

        // Keyboard navigation
        document.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    getAllImages() {
        const images = [];
        const imageItems = document.querySelectorAll('.image-item img');

        imageItems.forEach(img => {
            images.push({
                src: img.src,
                alt: img.alt
            });
        });

        // Se non ci sono immagini, usa l'immagine cover come fallback
        if (images.length === 0) {
            const coverImg = document.querySelector('.cover-image img');
            if (coverImg) {
                images.push({
                    src: coverImg.src,
                    alt: coverImg.alt
                });
            }
        }

        return images;
    }

    generateThumbnails() {
        const images = this.getAllImages();

        return images.map((img, index) => `
            <div class="lite-gallery-thumb ${index === 0 ? 'active' : ''}" data-index="${index}">
                <img src="${img.src}" alt="${img.alt}">
            </div>
        `).join('');
    }

    showImage(index) {
        if (index < 0 || index >= this.images.length) {
            return;
        }

        this.currentIndex = index;
        const modal = document.querySelector('.lite-gallery-modal');
        const mainImage = modal.querySelector('.lite-gallery-image');
        const thumbs = modal.querySelectorAll('.lite-gallery-thumb');

        // Aggiorna immagine principale
        if (mainImage && this.images[index]) {
            mainImage.src = this.images[index].src;
            mainImage.alt = this.images[index].alt;
        }

        // Aggiorna thumbnail attivo
        thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('active', i === index);
            if (i === index) {
                thumb.style.border = '2px solid #fff';
            } else {
                thumb.style.border = '2px solid transparent';
            }
        });

        // Mostra/nascondi navigazione
        const prevBtn = modal.querySelector('.lite-gallery-prev');
        const nextBtn = modal.querySelector('.lite-gallery-next');
        prevBtn.style.display = this.images.length > 1 ? 'block' : 'none';
        nextBtn.style.display = this.images.length > 1 ? 'block' : 'none';
    }

    prevImage() {
        const newIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.images.length - 1;
        this.showImage(newIndex);
    }

    nextImage() {
        const newIndex = this.currentIndex < this.images.length - 1 ? this.currentIndex + 1 : 0;
        this.showImage(newIndex);
    }

    closeLiteGallery() {
        // Ripristina lo scroll del body
        document.body.style.overflow = '';

        const modal = document.querySelector('.lite-gallery-modal');
        if (modal) {
            document.removeEventListener('keydown', this.handleKeydown.bind(this));
            modal.remove();
        }
    }

    handleKeydown(e) {
        switch (e.key) {
            case 'Escape':
                this.closeLiteGallery();
                break;
            case 'ArrowLeft':
                this.prevImage();
                break;
            case 'ArrowRight':
                this.nextImage();
                break;
        }
    }

}

// Inizializza la classe ImageGallery
document.addEventListener('DOMContentLoaded', () => {
    window.imageGalleryInstance = new ImageGallery();
});